import type { FreshchatBootConfig } from '../types/freshchat';

export const getFreshchatConfig = (): FreshchatBootConfig => {
  return {
    token: import.meta.env.VITE_FRESHCHAT_TOKEN,
    hostUrl: import.meta.env.VITE_FRESHCHAT_HOST_URL,
    locale: import.meta.env.VITE_FRESHCHAT_LOCALE,
    isWidgetHidden: import.meta.env.VITE_FRESHCHAT_IS_WIDGET_HIDDEN === 'true',
  };
};
